import { DailyBonusModalProps } from './types';
import { useEffect, useMemo, useState } from 'react';

const MODAL_EXIT_TIME = 300;
const PRODUCT_EXIT_TIME = 400;

export const useDailyBonus = ({
  titleSize = '24px',
  onCollect,
  onClose,
  onAnimationSuccessEndNoPreview,
  isPreview = false,
  nextProducts,
  nextAvailableCollectUTC,
  showEvery,
  isBadgeNextProduct = false,
}: DailyBonusModalProps) => {
  const [open, setOpen] = useState(true);
  const [showNextProduct, setShowNextProduct] = useState(false);
  const [timeLeft, setTimeLeft] = useState<any | null>(null);
  const [startExitAnimProduct, setStartExitAnimProduct] = useState(false);
  const [startExitAnimModal, setStartExitAnimModal] = useState(false);
  const [nextAvailableDate, setNextAvailableDate] = useState<Date | undefined>(
    undefined,
  );

  useEffect(() => {
    if (isBadgeNextProduct) {
      setShowNextProduct(true);
    }
  }, [isBadgeNextProduct]);

  useEffect(() => {
    setNextAvailableDate(nextAvailableCollectUTC);
  }, [nextAvailableCollectUTC]);

  useEffect(() => {
    if (showNextProduct) {
      calculateTimeLeft();
    }
  }, [showNextProduct]);

  const calculateTimeLeft = () => {
    // for testing purposes
    let nextDate: Date = nextAvailableDate || new Date();
    if (showEvery && showEvery < 1440) {
      const currentDate = new Date();
      nextDate = new Date(currentDate.getTime() + showEvery * 60000);
    }

    if (nextDate) {
      const interval = setInterval(() => {
        const remainingTime = nextDate.getTime() - new Date().getTime();
        setTimeLeft(remainingTime);
        if (remainingTime < 1000) {
          clearInterval(interval);
          window.location.reload();
        }
      }, 1000);
      return () => clearInterval(interval);
    }
  };

  const onCollectClicked = () => {
    if (isPreview) return;
    onCollect();
  };

  const onOrderSuccess = () => {
    if (!isBadgeNextProduct) {
      setStartExitAnimProduct(true);
      if (nextProducts && nextProducts.length > 0) {
        setTimeout(() => {
          setShowNextProduct(true);
        }, PRODUCT_EXIT_TIME);
      } else {
        setTimeout(() => {
          setStartExitAnimModal(true);
        }, PRODUCT_EXIT_TIME);
        setTimeout(() => {
          setOpen(false);
          if (onAnimationSuccessEndNoPreview) onAnimationSuccessEndNoPreview();
        }, PRODUCT_EXIT_TIME + MODAL_EXIT_TIME);
      }
    }
  };

  const onOrderFail = () => {
    // console.log('on order fail');
    // setStartExitAnimProduct(true);
    // onCloseClick();
  };

  const onCloseClick = () => {
    if (isPreview) return;
    setStartExitAnimModal(true);
    setTimeout(() => {
      setOpen(false);
      if (onClose && !isBadgeNextProduct)
        onClose({ isShowingNextProduct: showNextProduct });
    }, MODAL_EXIT_TIME);
  };

  const numberTitleSize = useMemo(() => {
    const match = titleSize.match(/^\d+/);
    return match ? parseInt(match[0], 10) : 0;
  }, [titleSize]);

  return {
    open,
    showNextProduct,
    timeLeft,
    startExitAnimProduct,
    startExitAnimModal,
    numberTitleSize,
    onCloseClick,
    onCollectClicked,
    onOrderSuccess,
    onOrderFail,
  };
};
